import { render } from "./base-menu.vue?vue&type=template&id=4fcde6c9&ts=true"
import script from "./base-menu.vue?vue&type=script&lang=ts"
export * from "./base-menu.vue?vue&type=script&lang=ts"

import "./base-menu.vue?vue&type=style&index=0&id=4fcde6c9&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__